import { ADD_TO_CART, INCREMENT_QUANTITY, DECREMENT_QUANTITY, DELETE_ITEM } from "./actionTypes";

export const addToCart = (productInfo) => {
    return {
        type: ADD_TO_CART,
        payload: productInfo,
    }
}

export const incrementQuantity = (id, value) => {
    return {
        type: INCREMENT_QUANTITY,
        payload: {
            id, 
            value,
        }
    }
}

export const decrementQuantity = (id, value) => {
    return {
        type: DECREMENT_QUANTITY,
        payload: {
            id, 
            value,
        }
    }
}

export const deleteItem = (id) => {
    return {
        type: DELETE_ITEM,
        payload: id,
    }
}

